module.exports = __webpack_public_path__ + "img/brochure_CR-mockup4.148157c9.jpg";